import Menu from "./menu";

export default function Portfolio() {
  return (
    <>
      <div className="col-12 col-md-12 col-xl-9">
        <div className="box-outer pb-0">
          <Menu />
          <div className="pb-3">
            <h1 className="title title--h1 title__separate">Portfolio</h1>
          </div>
          <div className="gallery-grid js-masonry js-filter-container row">
            <div className="col-md-4 gallery-grid__item category-frontend-development">
              <a href="https://ufogaming.io/" target="blank">
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/ufo_gaming.png"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">UFO Gaming</h3>
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-frontend-development">
              <a href="https://sushi.com/" target="blank">
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/sushi.png"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">Sushi</h3>
                  {/* <span className="gallery-grid__category">Web Development</span> */}
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-frontend-development">
              <a href="https://theanimal.farm/" target="blank">
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/animal_farm.png"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">The Animal Farm</h3>
                  {/* <span className="gallery-grid__category">Web Development</span> */}
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-frontend-development">
              <a href="https://app.metagods.gg/" target="blank">
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/metagods.png"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">Metagods</h3>
                  {/* <span className="gallery-grid__category">Web Development</span> */}
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-frontend-development">
              <a href="https://eventssmarter.com" target="blank">
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/eventssmarter.PNG"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">EventsSmarter</h3>
                  {/* <span className="gallery-grid__category">Web Development</span> */}
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-frontend-development">
              <a href="https://barkrz.com" target="blank">
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/barkrz.png"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">Barkrz</h3>
                  {/* <span className="gallery-grid__category">Web Development</span> */}
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-backend-development">
              <a
                href="https://apps.apple.com/us/app/bsp-comics/id1536158711"
                target="blank"
              >
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/blacksands.jpg"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">Blacksands</h3>
                  {/* <span className="gallery-grid__category">Backend Development</span> */}
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-backend-development">
              <a
                href="https://apps.apple.com/us/app/home-workout-no-equipments/id1313192037"
                target="blank"
              >
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/homeworkout.jpg"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">Home Workout</h3>
                  {/* <span className="gallery-grid__category">Backend Development</span> */}
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-backend-development">
              <a
                href="https://QuickTutor.com"
                target="blank"
              >
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/quicktutor.png"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">Quick Tutor</h3>
                  {/* <span className="gallery-grid__category">Backend Development</span> */}
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-frontend-development">
              <a href="https://commercial.nextres.com" target="blank">
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/commercial_nextres.png"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">Commercial Nextres</h3>
                </div>
              </a>
            </div>

            <div className="col-md-4 gallery-grid__item category-frontend-development">
              <a href="https://wholesale.nextres.com" target="blank">
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/wholesale_amres.png"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">Wholesale Nextres</h3>
                </div>
              </a>
            </div>
            <div className="col-md-4 gallery-grid__item category-frontend-development">
              <a href="https://finresi.com" target="blank">
                <div className="gallery-grid__image-wrap">
                  <img
                    className="gallery-grid__image cover lazyload"
                    src="assets/images/projects/finresi.png"
                    alt=""
                  />
                </div>
                <div className="gallery-grid__caption">
                  <h3 className="title gallery-grid__title">Finresi</h3>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
